// pages/index.jsx    ← or components/LandingPage.jsx, App.jsx, etc.
// This is the "glue" file that renders the full landing page

import React from 'react';
import HeroSection from '../components/HeroSection';
import FeatureHighlights from '../components/FeatureHighlights';
import PricingSection from '../components/PricingSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

// Optional: add a Navbar if you have one
// import Navbar from '../components/Navbar';

export default function LandingPage() {
    return (
        <div className="min-h-screen bg-white">
            {/* <Navbar />  ← uncomment/add if you have a top nav */}

            <HeroSection />
            <FeatureHighlights />
            <PricingSection />
            <FAQSection />
            <CTASection />
            <Footer />

        </div>
    );
}